export class MobileNav{
  constructor(
    private toggleButton:string,
    private navMenu:string,
    private childClass:string,
    private childToggleBtnClass:string
  ){}

  public init(){
    const TB = document.getElementById(this.toggleButton);
    const navMenu = document.getElementById(this.navMenu);
    const Bd = document.body;
    const nav = document.getElementById('ecn-navbar');

    
    if(TB && navMenu && Bd && nav){
      TB.addEventListener('click',()=>{
        navMenu.classList.toggle('show');
        if(navMenu.classList.contains('show')){
          Bd.classList.add('navmenu-open');
        }else{
          Bd.classList.remove('navmenu-open');
        }
      })


      //sticky header

      let  sticky = nav.offsetTop;
      window.onscroll = function() {
        if (window.pageYOffset > sticky) {
          nav.classList.add("sticky");
        } else {
          nav.classList.remove("sticky");
        }
      };
    }

    setTimeout(()=>{
      this.handleSubmenu();
    },500)
    
  }

  public handleSubmenu(){
    
    const childElements = document.getElementsByClassName(this.childClass);
    const childToggleBtns = document.getElementsByClassName(this.childToggleBtnClass);

    if(childElements && childElements.length>0 && childToggleBtns && childToggleBtns.length>0){
     
      for(let i = 0 ; i < childToggleBtns.length; i++){
        childToggleBtns[i].addEventListener('click',()=>{
          childElements[i].classList.toggle('showMenu')
          if(childElements[i].classList.contains('showMenu')){
            childToggleBtns[i].classList.add('rotate-180');
          }else{
            childToggleBtns[i].classList.remove('rotate-180');
          }
        });
      }

    }
  }


  public closeMenu(){
    const TB = document.getElementById(this.toggleButton);
    const navMenu = document.getElementById(this.navMenu);
    const Bd = document.body;
    if(TB && navMenu && Bd){
      Bd.classList.remove('navmenu-open');
      navMenu.classList.remove('show');
    }
  }
}